<template>
    <b-card style="">
      <h4 class="card-header">Dispute Letter Timeline</h4>
      <div class="card-body pt-1" style="overflow:auto;" v-if="letterLength != 0">
        <ul class="timeline ms-50">
          <!-- get all dispute letters -->
          <li class="timeline-item" v-for="(letter,index) in letters" :key="index">
            <span class="timeline-point timeline-point-info timeline-point-indicator" v-if="letter.status.id == 1"></span>
            <span class="timeline-point timeline-point-danger timeline-point-indicator" v-if="letter.status.id == 2"></span>
            <span class="timeline-point timeline-point-success timeline-point-indicator" v-if="letter.status.id == 3"></span>
            <span class="timeline-point timeline-point-warning timeline-point-indicator" v-if="letter.status.id == 4"></span>
            <div class="timeline-event">
              <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                <h6>
                  {{letter.name}}
                  <span class="badge badge-info" v-if="letter.status.id == 1">{{letter.status.status_name}}</span>
                  <span class="badge badge-danger" v-if="letter.status.id == 2">{{letter.status.status_name}}</span>
                  <span class="badge badge-success" v-if="letter.status.id == 3">{{letter.status.status_name}}</span>
                  <span class="badge badge-warning" v-if="letter.status.id == 4">{{letter.status.status_name}}</span>
                </h6>
                <span class="timeline-event-time me-1">{{letter.timePosted}}</span>
              </div>
              <p class="mb-0">Created {{letter.timePosted}}</p>
              <div class="d-flex flex-row align-items-center mt-50" style="cursor:pointer;" v-on:click="downloadDocument(letter.id)">
                <img class="me-1" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/icons/pdf.png" alt="data.json" height="25" style="height:28px;margin-right:4px">
                <h6 class="mb-0">{{letter.lettername}}.pdf</h6>
              </div>
            </div>
          </li>
        </ul>
        <b-row>
          <b-col cols="12">
          <!-- pagination -->
            <div class="my-2 d-flex justify-content-center">
                  <pagination v-model="currentPage" :records="rows" :per-page="perPage" @paginate="getUserDisputes"/>
            </div>

          </b-col>
        </b-row>
      </div>
      <div v-else>
        <p class="text-center  font-weight-bold text-capitalize">No Dispute Letter</p>
      </div>
    </b-card>
</template>
<script>
import {BCard,BRow,BCol} from 'bootstrap-vue-3'
  export default{
    name:'UserActivityTimeline',
    components:{

    },
    data(){
      return{
        letters:[],
        letterLength:0,
        currentPage: 0,
        perPage: 0,
        prevPage:'',
        nextPage:'',
        rows: 0,
        baseUrl: baseUrl
      }
    },
    created(){
      this.getUserDisputes();
    },
    methods:{
      async getUserDisputes(page){
        if(typeof page == null || typeof page == undefined){
          page = 1
        }
        let status ={
          status:0
        }
        axios.post(`${this.baseUrl}/profile/disputeletter?page=${+page}`,status).then(({data})=>{
          let pageData = data.data;
          this.letters=pageData.data
          this.letterLength=pageData.data.length
          this.currentPage = pageData.current_page

          this.perPage = pageData.per_page
          this.prevPage = pageData.prev_page_url
          this.nextPage = pageData.next_page_url
          this.rows = pageData.total
        }).catch()
      },
      downloadDocument(letterId){
        window.location.href=`${this.baseUrl}/disputes/letterDownload/${letterId}`;
      }
    }
  }
</script>
